'use client';

import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';

export function ProductClassifications() {
  const { t } = useTranslations();
  const manufacturers = useVariantsStore(state => state.product.manufacturers) || null;
  const categories = useVariantsStore(state => state.product.categories) ?? [];

  const variantCode = useVariantsStore(state => state.selectedVariant?.code);
  const category = categories[categories.length - 1];

  return (
    <div
      className={cn(
        'flex flex-col flex-wrap gap-3 md:flex-row md:items-center md:gap-6',
        'ea-product-detail-classifications',
      )}
    >
      <div
        className={cn(
          'flex flex-row items-center space-x-1',
          'ea-product-detail-classifications__badge-wrapper',
        )}
      >
        <span
          className={cn(
            'text-sm text-muted-foreground',
            'ea-product-detail-classifications__badge-title',
          )}
        >
          {t('text230')}
        </span>

        {!!category?.slug && (
          <Link
            href={category.slug ?? '#'}
            className={cn('', 'ea-product-detail-classifications__badge-link')}
            prefetch={false}
          >
            <Badge
              size={'md'}
              variant="secondary"
              className={cn('cursor-pointer', 'ea-product-detail-classifications__badge')}
            >
              {category.name}
            </Badge>
          </Link>
        )}
      </div>
      {!!manufacturers && (
        <div
          className={cn(
            'flex flex-row items-center space-x-1',
            'ea-product-detail-classifications__badge-wrapper',
          )}
        >
          <span
            className={cn(
              'text-sm text-muted-foreground',
              'ea-product-detail-classifications__badge-title',
            )}
          >
            {t('text785')}:
          </span>
          <div>
            {manufacturers.map((manufacturer: any, index: any) => (
              <Link
                key={`manufacturer-${manufacturer.id ?? manufacturer.slug ?? manufacturer.name ?? index}`}
                href={manufacturer.slug ?? '#'}
                className={cn('', 'ea-product-detail-classifications__badge-link')}
                prefetch={false}
              >
                <Badge
                  size={'md'}
                  variant="secondary"
                  className={cn('cursor-pointer', 'ea-product-detail-classifications__badge')}
                >
                  {manufacturer.name}
                </Badge>
              </Link>
            ))}
          </div>
        </div>
      )}

      {!!variantCode && (
        <div
          className={cn(
            'flex flex-row items-center space-x-1',
            'ea-product-detail-classifications__variant-code-wrapper',
          )}
        >
          <span
            className={cn(
              'text-sm text-muted-foreground',
              'ea-product-detail-classifications__variant-code-title',
            )}
          >
            {t('text433')}
          </span>
          <span
            className={cn(
              'text-sm text-muted-foreground',
              'ea-product-detail-classifications__variant-code',
            )}
          >
            {variantCode}
          </span>
        </div>
      )}
    </div>
  );
}
